import sycamoreServiceClient from '.';

export const postHandler = async (url, data) => {
    try {
        let response = await sycamoreServiceClient({
            url: url,
            method: 'post',
            data: data,
        });

        return response
        
    } catch (error) { return error.response}
};

export const getHandler = async (url) => {
    try {
        let response = await sycamoreServiceClient({
            url: url,
            method: 'get',
        });

        return response

    } catch (error) { return error.response }
};
